import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAccessKey } from "./baseQuery";

export const campaignApi = createApi({
  reducerPath: "campaignApi",
  baseQuery: baseQueryWithAccessKey,
  endpoints: (builder) => ({
    getCampaignAds: builder.query({
      query: (params) => ({
        url: "/api/glabp/",
        params,
      }),
    }),
    getCampaignAdStats: builder.query({
      query: ({ glid, chart_type }) => ({
        url: "/api/glabp/",
        params: { page: "ChartData", glid, chart_type },
      }),
    }),
  }),
});

export const { useGetCampaignAdsQuery, useGetCampaignAdStatsQuery } =
  campaignApi;
